import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentCourseSpeechRateGauge from './ContentCourseSpeechRateGauge';
import { ContentCourseSpeechRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentCourseSpeechRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentCourseSpeechRateListService.load();
  }
  render() {
    const data = ContentCourseSpeechRateListService.getChart();
    return (
      <ContentCourseSpeechRateGauge
        loading={
          ContentCourseSpeechRateListService.fetchCurrent.fetching ||
          ContentCourseSpeechRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentCourseSpeechRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('UNIT_ITEM_EXECUTION_SPEECH_RATE')}
      />
    );
  }
}

export default observer(ContentCourseSpeechRateGaugeContainer);
